import React, { useState, useEffect } from "react";
import Base from "../layout/BaseTemplate";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import useToken from "../authentication/token";
import RxnTable from "../layout/components/RxnTable";
import { Button } from "react-bootstrap";
import { IconAddOutline } from "../layout/components/SVGs";

export default function BioisosteresBrowser() {
  const navigate = useNavigate();
  const [data, setData] = useState({
    columns: [
      {
        label: "Replacement",
        field: "replacement",
      },
      {
        label: "Smarts",
        field: "smarts",
      },
      // {
      //   label: "Category",
      //   field: "category",
      // },
      {
        label: "Level",
        field: "level",
        sortable: true,
      },
      {
        label: "MWt",
        field: "size_change",
        sortable: true,
      },
      {
        label: "LogP",
        field: "logp_change",
        sortable: true,
      },
      // { hide this for now 
      //   label: "Solubility Change",
      //   field: "solubility_change",
      // },
      {
        label: "Metabolic Stability",
        field: "metabolic_stability",
        sortable: true,
      },
      {
        label: "Rigidity",
        field: "rigidity_change",
        sortable: true,
      },
      {
        label: "Sp3 Bond",
        field: "sp3_bond_change",
        sortable: true,

      },
      {
        label: "HBA",
        field: "hba",
        sortable: true,
      },
      {
        label: "HBD",
        field: "hbd",
        sortable: true,
      },
      {
        label: "References",
        field: "refs",
      }
    ],
    data: [],
  });

  const [tags, setTags] = useState([]);
  const { token } = useToken();
  const [loading, setLoading] = useState(false);
  // const [childString, setChildString] = useState("");

  // function getTagList() {
  //     axios({
  //         method: "GET",
  //         url: "/bioisostere",
  //     }).then((res) => {
  //         let getTagLabels = [];
  //         // for (let i = 0; i < res.data.tags.length; i++) {
  //         //     getTagLabels.push({
  //         //         label: res.data.tags[i].label,
  //         //         value: res.data.tags[i].value,
  //         //     });
  //         // }
  //         // setTags(getTagLabels);
  //     });
  // }

  async function getRxns() {
    setLoading(true);
    await axios({
      method: "GET",
      url: "/bioisostere/",
    }).then((res) => {
      setData({ ...data, data: res.data });
      localStorage.setItem("bioisosteres", JSON.stringify(res));
    });
    setLoading(false);
  }

  useEffect(() => {
    //getTagList();
    // if (localStorage.getItem("bioisosteres")) {
    //     setData({
    //         ...data,
    //         data: JSON.parse(localStorage.getItem("bioisosteres"))["data"],
    //     });
    // } else {
    getRxns();
  }, []);

  return (
    <Base>
      <RxnTable
        striped
        bordered
        hover
        hasTags
        rxnCache
        data={data}
        tags={tags}
        token={token}
        loading={loading}
        actions={{
          view: true,
          viewLogic: () => console.log(),
          add: true,
          addLogic: () => (
            <Button onClick={() => navigate("/register_bioisostere")}>
              <IconAddOutline />
            </Button>
          ),
        }}

      // actions={{
      //   view: true,
      //   // viewLogic: (target) => navigate("/reactions/" + target.rxn_id),
      //   // add: true,
      //   // addLogic: () => (
      //   //     <Button onClick={() => navigate("/register_reaction")}>
      //   //         <IconAddOutline />
      //   //     </Button>
      //   // ),
      // }}
      // updateChildString={(value) => setChildString(value)}
      ></RxnTable>
      {/* {console.log(childString)} */}
    </Base>
  );
}
